import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { api } from '@/services/api'
import type { User, Role } from '@/types'

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User | null>(null)
  const loading = ref(false)
  const initialized = ref(false)

  const isAuthenticated = computed(() => user.value !== null)
  const role = computed<Role | null>(() => user.value?.role ?? null)
  const isAdmin = computed(() => role.value === 'admin')
  const canEdit = computed(() => role.value === 'admin' || role.value === 'gestor' || role.value === 'colaborador')

  async function login(email: string, password: string) {
    loading.value = true
    try {
      const r = await api.post('/auth/login', { email, password })
      user.value = r.data.user
    } finally {
      loading.value = false
    }
  }

  async function logout() {
    try {
      await api.post('/auth/logout')
    } catch {}
    user.value = null
  }

  async function fetchMe() {
    try {
      const r = await api.get('/me')
      user.value = r.data.user
    } catch {
      user.value = null
    } finally {
      initialized.value = true
    }
  }

  async function changePassword(senhaAtual: string, novaSenha: string) {
    if (!user.value) return
    await api.patch(`/users/${user.value.id}/senha`, {
      senha_atual: senhaAtual,
      nova_senha: novaSenha,
    })
  }

  return {
    user,
    loading,
    initialized,
    isAuthenticated,
    role,
    isAdmin,
    canEdit,
    login,
    logout,
    fetchMe,
    changePassword,
  }
})
